import React from 'react';
import { css } from '@emotion/react';
import { color } from '@/styles';
import { useTranslation } from 'react-i18next';
import { recordColors, getRecordNames } from './common';

const CareRecordLabelRow = css`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const CareRecordLabel = css`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 100%;
  margin-right: 32px;

  color: ${color.dark_gray};
  & > span {
    margin-left: 8px;
  }
`;

const SymbolScale = css`
  width: 12px;
  height: 12px;
`;

const SymbolStyle = (symbolColor: string, shape: 'circle' | 'rect') => css`
  ${SymbolScale};
  background-color: ${symbolColor};
  ${shape === 'circle' ? ` border-radius: 6px; ` : `border: 1px solid ${color.border_gray};`};
`;

const LabelItem = ({ color, label, shape = 'rect' }: { color: string; label: string; shape?: 'circle' | 'rect' }) => (
  <div css={CareRecordLabel}>
    <div css={SymbolStyle(color, shape)} />
      <span>{label}</span>
  </div>
);

export const NotifyAndCareRecordLabel = () => {
  const {t} = useTranslation();
  const recordNames = getRecordNames(t);

  return (
    <div>
      <div css={CareRecordLabelRow}>
        <LabelItem color={color.notification_orange_odor} label={t('odorDetectionNotification', '臭い検知通知')} shape='circle' />
        <LabelItem color={color.notification_green} label={t('estimatedTimeOfDefecationNotification', '排便予測時間通知')} shape='circle' />
      </div>
      <div css={CareRecordLabelRow}>
        <LabelItem color={recordColors.defecationAndUrine} label={recordNames.defecationAndUrine} shape='rect' />
        <LabelItem color={recordColors.defecation} label={recordNames.defecation} shape='rect' />
        <LabelItem color={recordColors.urine} label={recordNames.urine} shape='rect' />
        <LabelItem color={recordColors.none} label={recordNames.none} shape='rect' />
      </div>
    </div>
  );
};
